import React from "react";
import Solicitudes from "../../components/0. Tablas/SolicitudesTable";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
